import { apiClient } from "../../lib/apiClient";

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: "super_admin" | "project_user";
  status: "active" | "disabled";
  last_login_at: string | null;
  projects_count: number;
  disabled_at: string | null;
  disabled_by: string | null;
}

export async function listUsers(): Promise<AdminUser[]> {
  const r = await apiClient.get<{ users: AdminUser[] }>("/api/admin/users");
  return r.data.users;
}

export async function promoteUser(id: string): Promise<void> {
  await apiClient.post(`/api/admin/users/${encodeURIComponent(id)}/promote`);
}

export async function demoteUser(id: string): Promise<void> {
  await apiClient.post(`/api/admin/users/${encodeURIComponent(id)}/demote`);
}

export async function disableUser(id: string): Promise<void> {
  await apiClient.post(`/api/admin/users/${encodeURIComponent(id)}/disable`);
}

export async function enableUser(id: string): Promise<void> {
  await apiClient.post(`/api/admin/users/${encodeURIComponent(id)}/enable`);
}

// Admin-initiated password reset — sends a magic-link to the user's inbox.
// POST /api/admin/users/{id}/password-reset → 204. Route is super-admin gated;
// failures (403 / 404) surface via the global error toast.
export async function sendPasswordReset(id: string): Promise<void> {
  await apiClient.post(
    `/api/admin/users/${encodeURIComponent(id)}/password-reset`,
  );
}

export interface CreatePlatformInviteInput {
  email: string;
  role: "super_admin" | "project_user";
  game_id?: string;
}

export async function createPlatformInvite(
  input: CreatePlatformInviteInput,
): Promise<void> {
  await apiClient.post("/api/admin/invites", input);
}
